import { initInterviewClientState } from "./interview-client.inits";

/** @type {(import("vuex").Module<import("./interview-client.inits").InterviewClientState>)} */
export const client = {
    namespaced: true,

    state: initInterviewClientState(),

    mutations: {
        setStream(state, { stream }) {
            state.stream = stream;
        },
        setStream_media(state, { stream_media }) {
            state.stream_media = stream_media;
            let audio = state.stream_media.getAudioTracks()[0];
            let video = state.stream_media.getVideoTracks()[0];
            state.enabled_audio = audio.enabled;
            state.enabled_video = video.enabled;
        },
        toggleAudio(state) {
            let track = state.stream_media.getAudioTracks()[0];
            track.enabled = !track.enabled;
            state.enabled_audio = track.enabled;
        },
        toggleVideo(state) {
            let track = state.stream_media.getVideoTracks()[0];
            track.enabled = !track.enabled;
            state.enabled_video = track.enabled;
        },
        toggleMuted(state) {
            state.enabled_muted = !state.enabled_muted;
        },
    },

    actions: {
        async init({ commit, rootState }) {
            if (rootState.interview.loading) return;
            commit("interview/setLoading", { loading: true }, { root: true });

            try {
                const stream_media = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: { facingMode: "user" },
                });
                commit("interview/client/setStream_media", { stream_media }, { root: true });
            } catch (error) {
                console.error(error);
            } finally {
                if (rootState.interview.loading) commit("interview/setLoading", { loading: false }, { root: true });
            }
        },
    },

    modules: {},
};
